// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPageText_cls1__Yo73O","cls2":"VeloLogoPageText_cls2__0t03B VeloLogoPageText_cls1__Yo73O"};